import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useLockBodyScroll from '../../hooks/useLockBodyScroll';
import CloseIcon from '../../assets/icons/CloseIcon';
import ModalPortal from './ModalPortal';
import { Overlay, ModalContainer, CloseModalButton } from './Modal.styles';
import useFocusTrap from '../../hooks/useFocusTrap';
import EDepositCloseIcon from '../../assets/icons/EDepositCloseIcon';

interface ModalProps {
  onClose: () => void;
  width?: string;
  modalOpen: boolean;
  eDeposit?: boolean;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ onClose, modalOpen, children, width, eDeposit }) => {
  const { t } = useTranslation();
  useLockBodyScroll();

  const FocusTrapRef = useFocusTrap(modalOpen, {
    // focusElementOnOpen: closeButtonRef?.current,
    focusElementOnClose: "button[data-component='results-toolbar-filter-toggle']",
  });

  const handleKeyPress = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    },
    [onClose],
  );

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      if (e.target !== e.currentTarget) return;
      onClose();
    },
    [onClose],
  );

  if (!modalOpen) {
    return null;
  }
  return (
    <ModalPortal>
      <Overlay
        aria-label={t('vehiclePricingBar.backdrop')}
        onKeyDown={handleKeyPress}
        onClick={handleClick}
        tabIndex={0}
      >
        <ModalContainer
          role="dialog"
          aria-label={t('vehiclePricingBar.modal')}
          aria-modal="true"
          width={width}
          tabIndex={0}
          ref={FocusTrapRef}
          eDeposit={eDeposit}
        >
          <CloseModalButton
            onClick={onClose}
            aria-label={t('vehiclePricingBar.closeModal')}
            eDeposit={eDeposit}
          >
            {eDeposit ? <EDepositCloseIcon /> : <CloseIcon size={48} />}
          </CloseModalButton>
          {children}
        </ModalContainer>
      </Overlay>
    </ModalPortal>
  );
};

export default Modal;
